module.exports = __webpack_public_path__ + "static/img/logo-jolly88.f51c656a.png";